import PageWrapper from 'common/components/PageWrapper';
import { useTranslation } from 'react-i18next';
import NotificationTab from 'modules/notification/components/notificationTab';


export default function NotificationPage(): JSX.Element {
    const { t } = useTranslation('notification');

    const LINKS = [
        {
            name: t('settings.short'),
        },
        {
            name: t('settings'),
            href: '/dashboard/notifications/settings',
        },
        {
            name: t('title'),
        },
    ];

    return (
        <PageWrapper
            titleHead={t('title')}
            title={t('title')}
            links={LINKS}
        >
            <NotificationTab />
        </PageWrapper>
    );
}